/* Important Info component for the Permissions info */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Callsheets.module.css";

const PermissionsInfo = () => {

  return (
   <div>
    <Row className="my-3">
    <Col md={{span: 10, offset: 1}}>
    <div className={`px-3 py-2 ${styles.SubTitle6}`}>
    <h5 className={`text-center ${styles.Red }`} >Permissions</h5>   
    <hr className={`mt-2 mb-0`}/>
    <p className="pt-2" >
      All Users must be given one of the below Permissions when Registered.
    </p> 
    <p className={`pt-2 ${styles.Ital }`} >
      Only Superadmin Users can Add/Update/Delete the Main Unit Shotlists, Schedules and Callsheets.
    </p> 
    <p className={`pt-2 ${styles.Ital }`} >
      Superadmin and Admin Users can Add/Update/Delete the 2nd Unit Schedules and Callsheets.
    </p> 
    <div>
    <p className="pt-5" >
      <span className={`${styles.Red}`}>* Superadmin</span>:
    </p>
    <p className="pt-2" >
      Complete access to all features <span className={`${styles.Red}`}>including</span>:
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Shotlists, Schedule and Callsheets
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> The Unfreeze Scenes Button
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Delete Users
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Register and Update users in Manage Users
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Crew in Crew Info 
    </p>
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Cast in the Characters section
    </p>
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Delete or Edit other User's Workshop Posts and Comments
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Items in the Production Tracker
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Scenes and Episodes
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Scene: Breakdowns, Characters/Costumes, Storyboards and Scripts
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Characters and Characters Images
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Locations, Location Filming Details and Location Images
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Moodboards, Index Cards and Indexshots 
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Department and Latest Buzz posts
    </p> 
    </div>
    <div>
    <p className="pt-5" >
      <span className={`${styles.Red}`}>* Admin</span>:
    </p>
    <p className="pt-2" >
      Complete access to all the above features <span className={`${styles.Red}`}>excluding</span>: 
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Shotlists, Schedule and Callsheets
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> The Unfreeze Scenes Button 
    </p>
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Delete Users 
    </p>
    </div>
    <div>
    <p className="pt-5" >
      <span className={`${styles.Red}`}>* Admincreative</span>:
    </p>
    <p className="pt-2" >
      Similar to Admin but also <span className={`${styles.Red}`}>excluding</span>: 
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Register, Update Delete users in Manage Users
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Actors info in the Characters section
    </p>
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Delete or Edit other User's Posts and Comments
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Scenes and Episodes
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete Shotlists, Schedule Stripboards and Callsheets
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Delete Characters and Scenes
    </p> 
    <p className="pt-1" >
      <span className={`${styles.Red}`}>-</span> Delete Location and Add/Update/Delete Location Filming Details
    </p> 
    </div>
    <div>
    <p className="pt-5" >
      <span className={`${styles.Red}`}>* Crew</span>:
    </p>
    <p className="pt-2" >
      Only View access for all <span className={`${styles.Red}`}>excluding</span>:
    </p> 
    <p className="pt-2" >
      <span className={`${styles.Red}`}>-</span> Add/Update/Delete own Scene Workshop and Departments Posts
    </p> 
    </div>
    <div>
    <p className="pt-5" >
      <span className={`${styles.Red}`}>* Cast</span>:
    </p>
    <p className="pt-2" >
      Only View access to <span className={`${styles.Red}`}>Callsheets</span>. 
    </p> 
    </div>
    <hr className={`mt-2 mb-0`}/>
    </div>
    </Col>
    </Row>
    </div>
)
}

export default PermissionsInfo